export const message = {
  officialAnswer: "Resposta oficial",
  answerCheckedMessage: "Resposta marcada com sucesso",
  setOfficialAnswerContent:
    "Tem certeza de que deseja marcar esta como a resposta oficial?",
};
